import Cookies from "js-cookie";
import { useContext } from "react";
import {
  AVC_AAA_CONFIG,
  AVC_ObjectFile_CONFIG,
  AVC_PROFILE_CONFIG,
  AVC_SITE_CONFIG,
  AVC_TICKETING_CONFIG,
  AVC_PERSONNAL_MANAGMENT_CONFIG,
  AVC_NOTIFICATION_CONFIG,
  AVC_PROSRV_CONFIG,
  AVC_ENERGY_MANAGEMENT_CONFIG,
  AVC_AUDITCONTROL_CONFIG,
  AVC_TRANSPORTATION_CONFIG,
  AVC_Orchestrator_CONFIG,
  AVC_FACILITIES_CONFIG,
  AVC_WATER_MANAGEMENT_CONFIG,
  AVC_LABORATORY_CONFIG,
  AVC_EDUCATION_CONFIG,
  AVC_MARKETING_CONFIG,
  AVC_CORRESPONDENCEMANAGEMENT_CONFIG,
} from "src/config/apollo-client/apolloclient";
import { UserContext } from "src/contexts/UserContext";
import useErrorHandling from "./useErrorHandling";

const useRequestBeforeLogin = () => {
  const { isLoggedin } = useContext(UserContext);
  const { errorHandling } = useErrorHandling();

  const getTokenWso2 = () => {
    return "Bearer " + Cookies.get("nmzbxcbashsaoisd");
  };

  function requestConfig(config) {
    let uri = null;
    if (config.module === "AVC_AAA") uri = AVC_AAA_CONFIG.AVC_AAA_uri;
    if (config.module === "AVC_PROFILE") uri = AVC_PROFILE_CONFIG.AVC_PROFILE_uri;
    if (config.module === "AVC_SITE") uri = AVC_SITE_CONFIG.AVC_SITE_uri;
    if (config.module === "AVC_TICKET") uri = AVC_TICKETING_CONFIG.AVC_TICKETING_uri;
    if (config.module === "avc_filestorage") uri = AVC_ObjectFile_CONFIG.AVC_ObjectFile_uri;
    if (config.module === "uploadfile") uri = AVC_ObjectFile_CONFIG.AVC_uploadFile_uri;
    if (config.module === "AVC_PERSONNAL_MANAGMENT") uri = AVC_PERSONNAL_MANAGMENT_CONFIG.AVC_PERSONNAL_MANAGMENT_uri;
    if (config.module === "AVC_NOTIFICATION") uri = AVC_NOTIFICATION_CONFIG.AVC_NOTIFICATION_uri;
    if (config.module === "AVC_PROSRV") uri = AVC_PROSRV_CONFIG.AVC_PROSRV_uri;
    if (config.module === "AVC_ENERGY_MANAGEMENT") uri = AVC_ENERGY_MANAGEMENT_CONFIG.AVC_ENERGY_MANAGEMENT_uri;
    if (config.module === "AVC_AUDITCONTROL") uri = AVC_AUDITCONTROL_CONFIG.AVC_AUDITCONTROL_uri;
    if (config.module === "AVC_TRANSPORTATION") uri = AVC_TRANSPORTATION_CONFIG.AVC_TRANSPORTATION_uri;
    if (config.module === "AVC_Orchestrator") uri = AVC_Orchestrator_CONFIG.AVC_ORCHESTRATOR_uri;
    if (config.module === "AVC_FACILITIES") uri = AVC_FACILITIES_CONFIG.AVC_FACILITIES_uri;
    if (config.module === "AVC_WATER_MANAGEMENT") uri = AVC_WATER_MANAGEMENT_CONFIG.AVC_WATER_MANAGEMENT_uri;
    if (config.module === "AVC_LABORATORY") uri = AVC_LABORATORY_CONFIG.AVC_LABORATORY_uri;
    if (config.module === "AVC_EDUCATION") uri = AVC_EDUCATION_CONFIG.AVC_Education_uri;
    if (config.module === "AVC_MARKETING") uri = AVC_MARKETING_CONFIG.AVC_MARKETING_uri;
    if (config.module === "AVC_CORRESPONDENCE_MANAGEMENT")
      uri = AVC_CORRESPONDENCEMANAGEMENT_CONFIG.AVC_CORRESPONDENCEMANAGEMENT_uri;

    let request = {
      fetchPolicy: "network-only",
      context: {
        credentials: "include",
        uri: uri,
        headers: {
          Microservice: config.Microservice,
          AuthorizationWSO2: getTokenWso2(),
        },
      },
      notifyOnNetworkStatusChange: true,
      onCompleted: config.onCompleted,
      onError: config?.onError
        ? config?.onError
        : (error) => {
            if (config?.errorShow !== "OFF") errorHandling(error);
          },
    };
    if (config.Microservice) request.Microservice = config.Microservice;
    if (config.variables) request.variables = config.variables;
    if (config?.hasUpload === true) request.context.hasUpload = true;

    return request;
  }

  function requestBeforeLoginConfig(config) {
    let uri = null;
    if (config.module === "AVC_AAA") uri = AVC_AAA_CONFIG.AVC_AAA_uri;
    if (config.module === "AVC_PROFILE") uri = AVC_PROFILE_CONFIG.AVC_PROFILE_uri;
    if (config.module === "AVC_SITE") uri = AVC_SITE_CONFIG.AVC_SITE_uri;
    if (config.module === "AVC_TICKET") uri = AVC_TICKETING_CONFIG.AVC_TICKETING_uri;
    if (config.module === "avc_filestorage") uri = AVC_ObjectFile_CONFIG.AVC_ObjectFile_uri;
    if (config.module === "uploadfile") uri = AVC_ObjectFile_CONFIG.AVC_uploadFile_uri;

    let request = {
      fetchPolicy: "network-only",
      skip: config.skip,
      context: {
        credentials: "include",
        uri: uri,
        headers: {
          Microservice: config.Microservice,
          AuthorizationWSO2: getTokenWso2(),
        },
      },
      notifyOnNetworkStatusChange: true,
      onCompleted: config.onCompleted,
      onError: config?.onError
        ? config?.onError
        : (error) => {
            if (config?.errorShow !== "OFF") errorHandling(error);
          },
    };
    if (config.Microservice) request.Microservice = config.Microservice;
    if (config.variables) request.variables = config.variables;
    if (config?.hasUpload === true) request.context.hasUpload = true;

    return request;
  }

  return { requestConfig, requestBeforeLoginConfig, getTokenWso2 };
};
export default useRequestBeforeLogin;
